import React from 'react'
import {KTSVG} from '../../../../../_metronic/helpers'
import clsx from 'clsx'
interface IconProps {
  type?: string
  classNameProp?: string
}

const Icon = ({type = '', classNameProp, ...props}: IconProps) => {
  const ListPahtIcons = {
    download: '/media/icons/duotune/files/fil021.svg',
  } as any
  const classNames = clsx('svg-icon-1', classNameProp)

  if (type === '') return <></>

  return <KTSVG path={ListPahtIcons[type]} className={classNames} />
}

export default Icon
